import { useContext } from "preact/hooks";
import { TranslateContext } from "@denysvuika/preact-translate";
import brivasteritorijas from '../../../assets/brivasteritorijas'

class ServicesService {
  async fetchServices() {
    // const { t, lang } = useContext(TranslateContext);
    const lang = document.querySelector("html").attributes.lang.value;
    const data = await (
      await fetch("/" + lang + "/api/v1/companies_map")
    ).json();

    const markers = data.map(function (val) {
      var label = "";
      if (val.services) {
        var services = val.services.split(",");
        [
          // 54,
          5,
          // 67,
          // 24,
          // 35,
          // 12,
          // 20,
          // 47,
          // 19,
          // 21,
          // 48,
          // 49,
          // 17,
          // 34,
          // 22,
          // 15,
          // 24,
          // 35,
          // 12,
          // 20,
          // 47,
          // 19,
          // 21,
          // 48,
          // 49,
          // 17,
          // 34,
          // 22,
          // 15,
          // 33,
          // 18,
          // 63,
          // 44,
          // 16,
          // 14,
          // 23,
        ].map(function (el) {
          // console.log('could add', services.indexOf(el + ""), val.title, val, services);
          if (services.indexOf(el + "") !== -1) {
            label = "K";
            // console.log('add', val.title, val, services);
          }
        });

        //pas
        if (services.indexOf("66") !== -1) {
          label = "P";
          //console.log("B", val, services.indexOf("66"));
        }
        [
          // 57, 64,
          65,
          // 39
        ].map(function (el) {
          if (services.indexOf(el + "") !== -1) {
            label = "J";
          }
        });
        // [56, 53, 52, 27, 38].map(function (el) {
        //   if (services.indexOf(el + "") !== -1) {
        //     label = "O";
        //   }
        // });
      }
      val["geometry"] = JSON.parse(val.field_atrasanas_vieta);
      var query = location.search.substring(1);
      var args = {};
      if (query) {
        query.split("&").map(function (el) {
          var arg = el.split("=");
          if (arg[1]) args[arg[0]] = arg[1];
        });
      }
      if (!args.l && args.n) {
        if (
          val.nid &&
          val.nid == args.n &&
          val.geometry &&
          val.geometry.coordinates
        ) {
          if (!flown) {
            flown = true;
            map.flyTo({
              center: val.geometry.coordinates,
              zoom: 16,
              essential: true, // this animation is considered essential with respect to prefers-reduced-motion
            });
          }
        }
      }
      val["properties"] = {
        nid: val.nid,
        title: val.title,
        label: label,
        description: val.title,
        "marker-size": "small",
      };

      if (val.services) {
        var services = val.services.split(",");
        for (var service in services) {
          val["properties"]["service" + services[service]] = true;
        }
      }
      return val;
    });

    // console.log(markers);

    [
      {
        type: "Feature",
        properties: {
          title: 'Piejūras dabas parks "Mīlestības saliņa"',
          danger_color: "",
          element_color: "blue",
          element_line_color: "#00B74A",
          text: "<br />id: 300",
          element_icon: null,
          element_line_weight: "2",
          model: "map.mapitem",
        },
        id: 300,
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [24.04264112319117, 57.05116112662577],
              [24.045731027976903, 57.04499853217853],
              [24.04555936659967, 57.04345772378877],
              [24.041182001487815, 57.03986225565622],
              [24.04744764174656, 57.03953537766134],
              [24.05311246718543, 57.039395286211615],
              [24.058004816428987, 57.03916179928805],
              [24.061008890525656, 57.03986225565622],
              [24.05414243544704, 57.04504522234394],
              [24.044186075584488, 57.05069429920848],
              [24.04264112319117, 57.05116112662577],
            ],
          ],
        },
      },
      // {
      //   type: "Feature",
      //   properties: {
      //     title: "Vecdaugavas dabas parks",
      //     danger_color: "",
      //     element_color: "blue",
      //     element_line_color: "#00B74A",
      //     text: "<br />id: 302",
      //     element_icon: null,
      //     element_line_weight: "2",
      //     model: "map.mapitem",
      //   },
      //   id: 302,
      //   geometry: {
      //     type: "Polygon",
      //     coordinates: [
      //       [
      //         [24.088485439673786, 57.048001538706956],
      //         [24.090620478049715, 57.046912780842575],
      //         [24.100662668602236, 57.05274829594984],
      //         [24.104525049583284, 57.06161652287794],
      //         [24.10409589614065, 57.064183245870325],
      //         [24.096886118309364, 57.06744972753672],
      //         [24.09396787490086, 57.06744972753672],
      //         [24.09233709181937, 57.05811616003349],
      //         [24.089676340477173, 57.053588534599335],
      //         [24.083839853660166, 57.05064761614364],
      //         [24.08612509574062, 57.049285393069525],
      //         [24.088485439673786, 57.048001538706956],
      //       ],
      //     ],
      //   },
      // },
      {
        type: "Feature",
        properties: {
          title: "Krēmeru dabas parks",
          danger_color: "",
          element_color: "blue",
          element_line_color: "#00B74A",
          text: "<br />id: 301",
          element_icon: null,
          element_line_weight: "2",
          model: "map.mapitem",
        },
        id: 301,
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [24.07980581130099, 57.00705505741433],
              [24.07886167372844, 57.00360797910794],
              [24.079258640662903, 57.00276186244406],
              [24.080374439613582, 57.002130822901364],
              [24.08689757193773, 57.001920474008166],
              [24.08699413146046, 57.00344438101131],
              [24.086414774313305, 57.00344438101131],
              [24.086522062674184, 57.00489336768637],
              [24.0860285362152, 57.004998533877355],
              [24.0860285362152, 57.00596838584731],
              [24.084376295461897, 57.00530234564804],
              [24.083517988577515, 57.00595670103451],
              [24.082251985922316, 57.00522055041508],
              [24.08145805205429, 57.00566457951609],
              [24.07980581130099, 57.00705505741433],
            ],
          ],
        },
      },
    ].map((feature) => {
      markers.push({
        type: "Feature",
        properties: {
          title: feature.properties.title,
          description: feature.properties.title,
          label: "Z",
        },
        geometry: {
          type: "Point",
          // coordinates: feature.geometry.coordinates[0][0],
          coordinates: this.getPCentroid(feature.geometry.coordinates[0]),
        },
      });
    });


    brivasteritorijas.features.map((feature) => {
      markers.push({
        type: "Feature",
        properties: {
          id: feature.id,
          ...feature.properties,
          title: feature.properties.title,
          description: feature.properties.title,
          label: "B",
        },
        geometry: {
          type: "Point",
          coordinates: this.getPCentroid(feature.geometry.coordinates[0]),
        },
      });
    })

    return markers;
  }
  getPCentroid(coordinates) {
    const { x, y } = this.get_polygon_centroid(
      coordinates.map(([x, y]) => ({ x, y }))
    );
    return [x, y];
  }
  get_polygon_centroid(pts) {
    var first = pts[0],
      last = pts[pts.length - 1];
    if (first.x != last.x || first.y != last.y) pts.push(first);
    var twicearea = 0,
      x = 0,
      y = 0,
      nPts = pts.length,
      p1,
      p2,
      f;
    for (var i = 0, j = nPts - 1; i < nPts; j = i++) {
      p1 = pts[i];
      p2 = pts[j];
      f =
        (p1.y - first.y) * (p2.x - first.x) -
        (p2.y - first.y) * (p1.x - first.x);
      twicearea += f;
      x += (p1.x + p2.x - 2 * first.x) * f;
      y += (p1.y + p2.y - 2 * first.y) * f;
    }
    f = twicearea * 3;
    return { x: x / f + first.x, y: y / f + first.y };
  }
}

export default new ServicesService();
